module.exports = __webpack_public_path__ + "static/media/2.be8b56b4.png";